import React from 'react';

const LinkIcon = class extends React.Component {
	render() {
		return (
			<svg fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg" viewBox="2 2 30 30" style={this.props.style||{}}>
				<path d="M9,17.5v2a.5.5,0,0,1-.5.5A4.5,4.5,0,0,1,4,15.5v-4A4.5,4.5,0,0,1,8.5,7h8A4.5,4.5,0,0,1,21,11.5v4A4.5,4.5,0,0,1,16.5,20a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5A1.5,1.5,0,0,0,18,15.5v-4A1.5,1.5,0,0,0,16.5,10h-8A1.5,1.5,0,0,0,7,11.5v4A1.5,1.5,0,0,0,8.5,17,.5.5,0,0,1,9,17.5ZM23.5,12a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5A1.5,1.5,0,0,1,25,16.5v4A1.5,1.5,0,0,1,23.5,22h-8A1.5,1.5,0,0,1,14,20.5v-4A1.5,1.5,0,0,1,15.5,15a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,0-.5-.5A4.5,4.5,0,0,0,11,16.5v4A4.5,4.5,0,0,0,15.5,25h8A4.5,4.5,0,0,0,28,20.5v-4A4.5,4.5,0,0,0,23.5,12Z"/>
			</svg>
		);
	}
}

export default LinkIcon;